import React, { useEffect, useState, useRef, Fragment } from "react"
import { Modal } from "components"
import { useLocation, useHistory } from "react-router-dom"
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa"
import { parse } from "query-string"

import { Button } from "components"
import { billplzPaymentStatus } from "services"
import classes from "./SpTopupResultModal.module.scss"

const SpTopupResultModal = (props) => {
  const { onWalletTopup, onContractUpdated } = props

  const history = useHistory()

  const location = useLocation()

  const query = parse(window.location.search)

  const [paymentResult, setPaymentResult] = useState(null)
  const [openTopupResultModal, setOpenTopupResultModal] = useState(false)

  const timeout = useRef(null)

  const handleDone = async () => {
    setOpenTopupResultModal(false)

    history.push(location.pathname, { replace: true })

    query["isTopup"] &&
      onWalletTopup()

    query["isSubscriptionPayment"] &&
      onContractUpdated()
  }

  const isPaymentFailed = () => {
    if (query["ZarinpalStatus"] !== "OK") {
      setPaymentResult(false)

      return true
    }

    return false
  }

  const checkBillplz = async () => {
    try {
      const { paymentStatus } =
        await billplzPaymentStatus(query["pId"])

      if (paymentStatus !== "paid") return

      setPaymentResult(true)

      clearInterval(timeout.current)
    } catch (err) {
      console.log(err)
    }
  }

  const handleEnter = () => {
    if (isPaymentFailed()) return

    timeout.current =
      setInterval(() => checkBillplz(), 1000)
  }

  useEffect(() => {
    setOpenTopupResultModal(!!query["ZarinpalStatus"])

    return () => clearInterval(timeout.current)
  }, [])

  return (
    <Modal
      onEnter={handleEnter}
      show={openTopupResultModal}
      onHide={() => setOpenTopupResultModal(false)}
      backdrop="static"
      
    >
      <div className={classes["container"]}>
        {paymentResult === null
          ?
          <div className={classes["please-wait"]}>
            <h3>لطفا منتظر بمانید</h3>
          </div>
          :
          <Fragment>
            {paymentResult
              ?
              <div className={classes["success"]}>
                <FaCheckCircle
                  size={60}
                  className={classes["icon"]}
                />
                <div className={classes["text"]}>
                  پرداخت با موفقیت انجام شد
                </div>
              </div>
              :
              <div className={classes["fail"]}>
                <FaTimesCircle
                  size={60}
                  className={classes["icon"]}
                />
                <div className={classes["text"]}>
                  پرداخت انجام نشد
                </div>
              </div>
            }
            <div className={classes["footer"]}>
              <Button
                color="success"
                onClick={handleDone}
              >
                تایید
              </Button>
            </div>
          </Fragment>
        }
      </div>
    </Modal>
  )
}

export default SpTopupResultModal